import axios from "axios";
import { useQuery, UseQueryOptions } from "react-query";
import { GeopuntResponse } from "types/backend";

export const useGeopuntLocation = (
  query: string,
  options: Pick<UseQueryOptions, "enabled">
) => {
  const baseUrl = "https://geo.api.vlaanderen.be/geolocation/v4";
  const queryOptions = {
    q: query,
    c: 5,
  };
  const fetch = async () => {
    const { data } = await axios.get<GeopuntResponse>(`${baseUrl}/Location`, {
      params: queryOptions,
    });
    return data.LocationResult;
  };
  return useQuery(["geopunt-location", query], fetch, {
    suspense: false,
    cacheTime: Infinity,
    staleTime: Infinity,
    ...options,
  });
};
